import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import PropTypes from 'prop-types';

const AdvicesMarkAsReadOrDownload = ((props) => {
  const { i18n: { messages }, downloadCount, markAsReadCount, downloadLoadingFlag, downloadDisabled } = props;

  return (
    <div className="markAdviceAsRead">
      {/* {markAsReadCount !== 0 &&
        <Button
          tertiary
          size='large'
          onClick={() => props.handleMarkasReadOnclick()}>
          {messages['app.chedelivery.reports.markasread'] + ` (` + markAsReadCount + `)`}
        </Button>} */}
      {downloadCount !== 0 &&
        <Button
          size='large'
          fullWidth={false}
          disabled ={downloadDisabled} /* WMCE-3044: document download disabled for RM Login on Behalf */
          tertiary={downloadDisabled}
          // loading={!!downloadLoadingFlag}
          onClick={() => props.handlePreviewnDownloadClick()}
        >
          {messages['app.chedelivery.reports.download'] + ` (` + downloadCount + `)`}
        </Button>}
    </div>
  );
});

AdvicesMarkAsReadOrDownload.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  count: PropTypes.bool
};

AdvicesMarkAsReadOrDownload.defaultProps = {
  i18n: {},
  count: 0
};

export default createContainer(
  {
    $queries: {
      app: {
        global: {
          deviceInfo: {
            isTablet: true,
          },
        },
      },
      edelivery: {
        getUserPreferences: { $call: 'getUserPreferences' },
        showPrompt: true,
      },
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      }
    }
  })(AdvicesMarkAsReadOrDownload);
